



































import {
  computed,
  defineComponent,
  Ref,
  ref,
  toRefs
} from '@nuxtjs/composition-api'
import { formFieldProps } from '~/constants/form'
import { BackendOption } from '~/models/shared/types'
import { useClassifiedForm } from '~/compositions/form'
import FieldError from '~/components/car/classifieds/form/fieldsets/fields/FieldError.vue'

export default defineComponent({
  components: { FieldError },
  props: formFieldProps,
  setup(props) {
    const { specs, name } = toRefs(props)

    const selectedValues = ref([])

    function onValue(v: Ref<any>) {
      selectedValues.value = v.value || []
    }

    const { valueChanged } = useClassifiedForm(props, { onValue })

    const options = computed(() => specs.value.values)

    const mixedInsuranceOption = computed(() =>
      options.value.find((o: BackendOption) => o.value === 'mixed_insurance')
    )
    const basicInsuranceOptions = computed(() =>
      options.value.filter(
        (o: BackendOption) => o.value !== mixedInsuranceOption.value.value
      )
    )

    function onValueChange(value: string[]) {
      valueChanged(name.value, value)
    }

    return {
      basicInsuranceOptions,
      mixedInsuranceOption,
      selectedValues,
      onValueChange
    }
  }
})
